```vue
<script setup lang="ts">
import { ref } from 'vue';
import PriceList from '../components/PriceList.vue';
import LaboratoryList from '../components/LaboratoryList.vue';

const activeTab = ref('price-list');
</script>

<template>
  <div>
    <nav class="mb-8">
      <ul class="flex space-x-2 justify-center bg-white rounded-lg p-2 shadow-sm">
        <li v-for="(tab, name) in {
          'price-list': 'Lista de Precios',
          'laboratories': 'Laboratorios'
        }" :key="name">
          <button
            @click="activeTab = name"
            :class="[
              'px-4 py-2 rounded-lg transition-all duration-200',
              activeTab === name
                ? 'bg-indigo-500 text-white shadow-sm'
                : 'text-slate-600 hover:bg-slate-100'
            ]"
          >
            {{ tab }}
          </button>
        </li>
      </ul>
    </nav>

    <main class="bg-white rounded-xl shadow-sm p-6">
      <PriceList v-if="activeTab === 'price-list'" />
      <LaboratoryList v-if="activeTab === 'laboratories'" />
    </main>
  </div>
</template>
```